import {
  Avatar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  makeStyles
} from "@material-ui/core";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import MaterialTable from "material-table";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { toast } from "react-toastify";
import {
  CommonUrl, logoutMsg, myHeaderStyle,
  mySearchFieldStyle, NONCE,
  processMsg,
  roomTypeBucketUrl,
  TIME_STAMP
} from "../common-url/CommonUrl";


const useStyles = makeStyles(theme => ({
  root: {
    "& .MuiPaper-root": {
      borderBottom: "none",
      backgroundColor: "transparent",
      boxShadow: "none"
    },
    "& .MuiInput-underline:before": {
      borderBottom: 0
    },
    "& .MuiInput-underline:after": {
      borderBottom: 0
    },
    "& .MuiInput-root": {
      borderBottom: 0
    },
    "&:last-child td": {
      // borderBottom: 0,
    }
  }
}));

export default function RoomTypes() {
  const [roomType, setRoomType] = useState([]);
  const [loading, setLoading] = useState(false);

  const classes = useStyles();

  const columns = [
    /*{ title: "Sr No", render: rowData => rowData.tableData.id + 1 },*/
    {
      title: "Image",
      field: "vFilePath",
      editable: false,
      filtering: false,
      render: rowData => (
        <div>
          {rowData.vFilePath == null ? (
            <Avatar>{rowData.vName}</Avatar>
          ) : (
            <Avatar
              className="border solid"
              src={roomTypeBucketUrl + rowData.vFilePath}
            />
          )}
        </div>
      )
    },
    {
      title: "Name",
      field: "vName",
      filterPlaceholder: "Name",
      validate: rowData => (rowData.vName ? true : "Name can not be empty")
    },
    {
      title: "Created At",
      field: "iCreatedAt",
      editable: false,
      filtering: false,
      render: rowData => (
        <span>
          {moment(rowData.iCreatedAt * 1000).format("MMMM Do YYYY, h:mm:ss a")}
        </span>
      )
    },
    {
      title: "Updated At",
      field: "iUpdatedAt",
      editable: false,
      filtering: false,
      defaultSort: "desc",
      render: rowData => (
        <span>
          {moment(rowData.iUpdatedAt * 1000).format("MMMM Do YYYY, h:mm:ss a")}
        </span>
      )
    }
  ];
  // ------------------------------------------------------
  // ------get the all room list at initial loading--------
  // ------------------------------------------------------
  const myTextIcon = React.useRef(null);
  useEffect(() => {
    fetchRooms();
    myTextIcon.current.parentNode.parentNode.classList.remove(
      "MuiIconButton-root"
    );
  }, []);
  const encToken = useSelector(({ auth }) => auth.authToken, shallowEqual);
  const history = useHistory();

  const fetchRooms = (async () => {
    await fetch(CommonUrl.roomTypeBaseUrl + "/get-all-room-type", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        token: encToken,
        nonce: NONCE,
        timestamp: TIME_STAMP
      }
    })
      .then(response => response.json())
      .then(response => {
        if (response.code == 401) {
          history.push("/logout");
          toast.info(logoutMsg, { autoClose: 5000 })
        } else {
          setRoomType(response.data);
        }
      });
  });

  // ------------------------------------------------------
  //                 adding a room type
  // ------------------------------------------------------

  const [openForm, setOpenForm] = useState(false);
  const [formData, setFormData] = useState({});

  const openAddForm = () => {
    setOpenForm(true);
  };
  const openUpdateForm = rowData => {
    setOpenForm(true);
    setFormData(rowData);
  };

  const handleRowAdd = e => {
    e.preventDefault();
    // console.log(formData.vName)
    // console.log(selectedImage, "add fired")
    setLoading(true);
    const id = toast.loading(processMsg);

    const data = new FormData();
    data.append("vFileDetails", selectedImage);
    data.append("vName", formData.vName);
    // console.log(selectedImage,"selectedImage.........");
    fetch(CommonUrl.roomTypeBaseUrl + "/add-room-type", {
      method: "post",
      body: data,
      headers: {
        token: encToken,
        nonce: NONCE,
        timestamp: TIME_STAMP
      }
    })
      .then(response => response.json())
      .then(response => {
        if (response.code === 200) {
          toast.update(id, {
            render: response.message,
            type: "success",
            isLoading: false,
            autoClose: 3000
          });
          fetchRooms();
          handleClose();
          setLoading(false);
        } else {
          toast.update(id, {
            render: response.message,
            type: "error",
            isLoading: false,
            autoClose: 3000
          });
          setLoading(false);
        }
      });
  };

  // ------------------------------------------------------
  //                 delete a room type
  // ------------------------------------------------------
  const handleRowDelete = (roomTableDeleteID, imageFile) => {
    // console.log("......handleRowDelete");
    setLoading(true);
    const id = toast.loading(processMsg);
    fetch(CommonUrl.roomTypeBaseUrl + "/delete-room-type", {
      method: "delete",
      headers: {
        "Content-Type": "application/json",
        token: encToken,
        nonce: NONCE,
        timestamp: TIME_STAMP
      },
      body: JSON.stringify({
        iMainId: roomTableDeleteID,
        vFilePath: imageFile
      })
    })
      .then(response => response.json())
      .then(response => {
        if (response.code === 200) {
          toast.update(id, {
            render: response.message,
            type: "success",
            isLoading: false,
            autoClose: 3000
          });
          fetchRooms();
          handleClose();
          setLoading(false);
        } else {
          toast.update(id, {
            render: response.message,
            type: "error",
            isLoading: false,
            autoClose: 3000
          });
          setLoading(false);
        }
      });
  };

  // ------------------------------------------------------
  //                   update a room type
  // ------------------------------------------------------

  const handleRowUpdate = e => {
    e.preventDefault();
    setLoading(true);
    const id = toast.loading(processMsg);
    fetch(CommonUrl.roomTypeBaseUrl + "/update-room-type", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        token: encToken,
        nonce: NONCE,
        timestamp: TIME_STAMP
      },
      body: JSON.stringify({
        iMainId: formData._id,
        vName: formData.vName
      })
    })
      .then(response => response.json())
      .then(response => {
        if (response.code === 200) {
          fetchRooms();
          toast.update(id, {
            render: response.message,
            type: "success",
            isLoading: false,
            autoClose: 3000
          });
          handleClose();
          setLoading(false);
        } else {
          toast.update(id, {
            render: response.message,
            type: "error",
            isLoading: false,
            autoClose: 3000
          });
          setLoading(false);
        }
      });
  };
  // ------------------------------------------------------
  // ----------------snackbar operations starts------------
  // ------------------------------------------------------

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenImage(false);
    setOpenForm(false);
    setTimeout(() => {
      setFormData({});
    }, 500);
  };
  // snackbar operations end

  // ------------------------------------------------------
  // --------------------Image Upload----------------------
  // ------------------------------------------------------

  const [selectedImage, setSelectedImage] = useState();
  const [openImage, setOpenImage] = useState(false);
  const [selectRowData, setSelectRowData] = useState({});

  const handleImage = (event, rowDetails) => {
    setSelectRowData(rowDetails);
    setOpenImage(true);
  };
  const handleSelectImage = event => {
    setSelectedImage(event.target.files[0]);
  };

  const handleUploadImage = (event, image) => {
    setLoading(true);
    const id = toast.loading(processMsg);
    const data = new FormData();
    data.append("vFileDetails", selectedImage);
    data.append("_id", selectRowData._id);
    data.append("oldFilePath", selectRowData.vFilePath);

    fetch(CommonUrl.roomTypeBaseUrl + "/upload-image", {
      method: "post",
      body: data,
      headers: {
        token: encToken,
        nonce: NONCE,
        timestamp: TIME_STAMP
      }
    })
      .then(response => response.json())
      .then(response => {
        if (response.code === 200) {
          // setOpenImage(false)
          toast.update(id, {
            render: response.message,
            type: "success",
            isLoading: false,
            autoClose: 3000
          });
          handleClose();
          setLoading(false);
          fetchRooms();
        } else {
          toast.update(id, {
            render: response.message,
            type: "error",
            isLoading: false,
            autoClose: 3000
          });
          // handleClose();
          setLoading(false);
        }
      });
  };

  // ---------------------------------------------------------------------
  // ---------------------------------------------------------------------

  return (
    <div className="App">
      <div>
        <Dialog
          open={openImage}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            Upload Image for{" "}
            <span className="text-primary">{selectRowData.vName}</span>
          </DialogTitle>
          <DialogContent>
            <input
              id="outlined-basic"
              className="form-control"
              type="file"
              onChange={handleSelectImage}
              required
            ></input>
          </DialogContent>
          <DialogActions>
            {/* <Button onClick={handleClose} color="secondary">Cancel</Button> */}
            {/* <Button onClick={handleUploadImage} color="primary" >Upload</Button> */}
            <Button
              type="submit"
              disabled={loading}
              onClick={handleUploadImage}
              className="col-sm-4 btn btn-light-primary px-9 py-3 my-3 mr-5"
            >
              <span>Upload</span>
              {loading && <span className="ml-3 spinner spinner-dark"></span>}
            </Button>
          </DialogActions>
        </Dialog>
      </div>

      <Dialog open={openForm} onClose={handleClose}>
        <div className="p-5">
          <DialogTitle id="alert-dialog-title" className="text-center ">
            <span className="text-primary">
              {formData._id ? "Update" : "Add"}
            </span>{" "}
            Room Type
          </DialogTitle>
          <form onSubmit={formData._id ? handleRowUpdate : handleRowAdd}>
            <DialogContent>
              <hr className="solid mt-0 mb-5"></hr>
              <div className="">
                <label className="col-sm-3 col-form-label font-weight-bold">
                  Name
                </label>
                <input
                  className="form-control"
                  placeholder="Enter Title"
                  type="text"
                  defaultValue={formData._id ? formData.vName : null}
                  onChange={e =>
                    setFormData({ ...formData, vName: e.target.value })
                  }
                  required
                ></input>
              </div>
            </DialogContent>
            <DialogContent>
              <div className={formData._id ? "d-none" : "form-group"}>
                <label className="col-sm-5 col-form-label font-weight-bold">
                  Image <span className="text-muted text-sm" style={{ fontSize: "10px" }}>(Max:2MB)</span>
                </label>
                <input
                  className="form-control"
                  placeholder="Enter Title"
                  type="file"
                  onChange={e => setSelectedImage(e.target.files[0])}
                  disabled={formData._id ? true : false}
                  required
                ></input>
              </div>
            </DialogContent>
            <div className=" row form-group justify-content-sm-center">
              {/* <Button type="submit" className="col-sm-6 btn btn-light-primary font-weight-bold" >Submit</Button> */}
              <Button
                type="submit"
                disabled={loading}
                className="col-sm-4 btn btn-light-primary px-9 py-3 my-3"
              >
                <span>Submit</span>
                {loading && <span className="ml-3 spinner spinner-dark"></span>}
              </Button>
            </div>
          </form>
        </div>
      </Dialog>

      {/* material table starts */}
      <div className={classes.root}>
        <div className="bg-white shadow rounded">
          <MaterialTable
            title="Room Type List"
            style={{ paddingInline: "30px", paddingTop: "10px" }}
            data={roomType}
            columns={columns}
            detailPanel={rowData => {
              if (rowData.vFilePath == null) {
                return (
                  <div
                    style={{
                      fontSize: 70,
                      textAlign: "center",
                      color: "white",
                      background: "linear-gradient(to top, #3699FF, #1BC5BD)"
                    }}
                  >
                    No Image Uploaded
                  </div>
                );
              }
              return (
                <div className="d-flex justify-content-center">
                  <img
                    title={rowData._id}
                    style={{
                      objectFit: "cover",
                      height: "500px",
                      display: "flex",
                      alignItems: "center"
                    }}
                    src={roomTypeBucketUrl + rowData.vFilePath}
                    frameborder="3"
                    alt="..."
                  />
                </div>
              );
            }}
            localization={{
              header: {
                actions: "Actions"
              }
            }}
            actions={[
              {
                icon: () => (
                  <div ref={myTextIcon}>
                    <button className="btn  btn-light-primary mx-6">
                      Add +
                    </button>
                  </div>
                ),
                tooltip: "Add Room Type",
                isFreeAction: true,
                onClick: () => {
                  openAddForm();
                }
              },
              {
                icon: "edit",
                iconProps: { color: "secondary" },
                tooltip: "Update Room Type",
                // isFreeAction: true,
                onClick: (e, rowData) => {
                  openUpdateForm(rowData);
                }
              },
              {
                icon: "upload",
                iconProps: { style: { color: "#ffa800" } },
                tooltip: "Upload Image",
                type: "file",
                onClick: (event, rowDetails) => {
                  // Do save operation
                  handleImage(event, rowDetails);
                }
              }
            ]}
            icons={{
              Delete: () => <DeleteOutlineIcon style={{ color: "#f64e60" }} />
            }}
            editable={{
              onRowDelete: selectedRow =>
                new Promise((resolve, reject) => {
                  const roomTableDeleteID = selectedRow._id;
                  const imageFile = selectedRow.vFilePath;
                  setTimeout(() => {
                    handleRowDelete(roomTableDeleteID, imageFile);
                    resolve();
                  }, 1000);
                })
            }}
            onRowClick={(evt, selectedRow, togglePanel) => togglePanel()}
            options={{
              actionsColumnIndex: -1,
              addRowPosition: "first",
              headerStyle: myHeaderStyle,
              // search:false,
              searchFieldStyle: mySearchFieldStyle,
              emptyRowsWhenPaging: false, // To avoid of having empty rows
            }}
          />
        </div>
      </div>
      {/* material table ends */}
    </div>
  );
}
